'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  /*@ngInject*/
  function _class($http, $filter, JSONToCSVConvertor, HourFinder, ColorFinder, ValidIndexes) {
    _classCallCheck(this, _class);

    this.$http = $http;
    this.$filter = $filter;
    this.search = {};
    this.JSONToCSVConvertor = JSONToCSVConvertor;
    this.HourFinder = HourFinder;
    this.ColorFinder = ColorFinder;
    this.ValidIndexes = ValidIndexes;
    this.results = [];
  }

  _createClass(_class, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$http.get('/api/tutors').then(function (response) {
        _this.tutors = response.data;
      });

      this.$http.get('/api/lessons').then(function (response) {
        _this.lessons = response.data;
      });

      this.$http.get('/api/students').then(function (response) {
        _this.students = response.data;
      });
    }
  }, {
    key: 'export',
    value: function _export(data) {
      data = data.map(function (entity) {
        return {
          clientName: entity.student.fullName,
          time: entity.totalTime
        };
      });

      data.push({ clientName: 'Total Time', time: this.totalTime });

      this.JSONToCSVConvertor(data, 'Tutor Export ' + this.search.tutor[0].fullName, true);
    }
  }, {
    key: 'returnFilter',
    value: function returnFilter(results, $query) {
      return results.filter(function (item) {
        return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this2 = this;

      this.results = [];
      var msDay = 1000 * 60 * 60 * 24;
      var _search = this.search,
          start = _search.start,
          end = _search.end,
          tutor = _search.tutor;


      if (!start || !end || !tutor.length) {
        return;
      }

      tutor = tutor[0];

      var tutorsLessons = this.lessons.filter(function (entity) {
        return entity.tutorUID === tutor._id;
      });
      tutorsLessons.forEach(function (entity) {
        return _this2.timeCompress(entity, start, end);
      });

      this.results = this.results.sort(function (a, b) {
        if (a.student.fullName < b.student.fullName) return -1;
        if (a.student.fullName > b.student.fullName) return 1;
        return 0;
      });

      this.totalTime = 0;

      this.results.forEach(function (ent) {
        _this2.totalTime += ent.totalTime;
      });

      this.less = this.results;
    }
  }, {
    key: 'timeCompress',
    value: function timeCompress(lesson, start, end) {
      var _this3 = this;

      lesson.student = this.students.find(function (student) {
        return lesson.clientUID == student._id;
      });

      var validIndexes = this.ValidIndexes(lesson, start, end);

      validIndexes.forEach(function (index) {
        var effectiveColor = _this3.ColorFinder(lesson, index);
        if (effectiveColor.includes('red') || effectiveColor.includes('grey') || effectiveColor.includes('yellow')) {
          return;
        };

        var student = {
          first: lesson.student.firstName,
          last: lesson.student.lastName,
          fullName: lesson.student.fullName
        };

        if (lesson.overwriteName && lesson.overwriteName[index]) {
          student.first = lesson.overwriteName[index];
          student.last = null;
          student.fullName = lesson.overwriteName[index] + ' - Overwritten Name';
        }

        _this3.addToResults({
          student: student,
          totalTime: _this3.HourFinder(lesson, index) / 60
        });
      });
    }
  }, {
    key: 'addToResults',
    value: function addToResults(data) {
      var foundIndex = this.results.findIndex(function (result) {
        return result.student.fullName === data.student.fullName;
      });

      if (foundIndex === -1) {
        return this.results.push(data);
      }

      this.results[foundIndex].totalTime += data.totalTime;
    }
  }]);

  return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/admin/export-tutor/export-tutor.controller.js